import {
  ChangeDetectionStrategy,
  Component,
  inject,
  signal,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { Store } from '@ngrx/store';
import { DoorModels } from '@models/door.model';
import { DoorsActions } from '@states/doors/doors.action-types';
import { UiButtonComponent } from '@ui';

interface DialogData {
  door: DoorModels.Door;
}

@Component({
  selector: 'app-door-edit-modal',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatDialogModule,
    TranslateModule,
    UiButtonComponent,
  ],
  templateUrl: './door-edit-modal.component.html',
  styleUrl: './door-edit-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DoorEditModalComponent {
  private readonly dialogRef = inject(MatDialogRef<DoorEditModalComponent>);
  protected readonly data = inject<DialogData>(MAT_DIALOG_DATA);
  private readonly store$ = inject(Store);

  protected readonly editableDoor = signal<DoorModels.Door>(
    structuredClone(this.data.door),
  );

  public onSave(): void {
    const door = this.editableDoor();
    this.store$.dispatch(DoorsActions.editDoor({ door }));
    this.close();
  }

  public onCancel(): void {
    this.close();
  }

  public close(): void {
    this.dialogRef.close();
  }
}
